import { Dispatch, SetStateAction } from 'react';
import { NavigateFunction } from 'react-router-dom';

import { AppDispatch } from '../../../../store/models/app-dispatch.model';
import { ReactComponent as WarningIcon } from '../../../shared/assets/icons/snackbar-icons/warning.svg';
import { SnackBarContextModel } from '../../../shared/components/snack-bar-context/models/snack-bar-context.model';
import { FirmwareDetailsFormModel } from '../../components/FirmwareDetailsForm/models/firmware-form.model';
import { FirmwareResponseModel } from '../../models/firmware-response.model';
import { setFirmwareFile } from '../../store/slices/firmware.slice';
import { getFirmwareById } from '../../thunk/get-firmware-by-id.thunk';
import { firmwareModelToFormik } from '../firmware-model-to-formik/firmware-model-to-formik.util';

export const populateUpdateFirmwareFields = async (
  firmwareId: number,
  dispatch: AppDispatch,
  setFields: Dispatch<SetStateAction<FirmwareDetailsFormModel>>,
  navigate: NavigateFunction,
  snackBarContext: SnackBarContextModel
): Promise<void> => {
  try {
    const data: FirmwareResponseModel = await dispatch(
      getFirmwareById(firmwareId)
    ).unwrap();
    setFields(firmwareModelToFormik(data));
    dispatch(setFirmwareFile(data.file));
  } catch {
    snackBarContext.changeSeverity('error');
    snackBarContext.changeIcon(<WarningIcon />);
    snackBarContext.changeMessage('Firmware not found !');
    snackBarContext.isOpen(true);
    navigate('/firmware-management/firmwares', { replace: true });
  }
};
